import classNames from 'classnames';
import styles from '@app/modules/projects/dashboard/shared/per-year-capital-structure/per-year-capital-structure-chart.module.scss';
import { FC, Fragment } from 'react';
import { InstrumentDefinitionAndInitialValues } from '@app/core/store/capital-structure-slice-selectors';
import { CapitalStructure } from '@app/modules/projects/inputs/capital-structure/capital-structure-types';
import { OpmForecastDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import OpmInstrumentBlockComponent from '@app/modules/projects/dashboard/opm-widgets/total-equity/OpmInstrumentBlock';

interface RankedInstrumentBlockProps {
  structure: CapitalStructure<InstrumentDefinitionAndInitialValues>;
  forecastIndex?: number;
  forecastData: OpmForecastDto[];
  chartForecastsCount: number;
}

const RankedInstrumentBlock: FC<RankedInstrumentBlockProps> = ({
  structure,
  forecastIndex,
  forecastData,
  chartForecastsCount,
}) => (
  <>
    {structure.ranks.map((rank, rankIndex) => {
      return (
        <Fragment key={`instrument-${rankIndex}`}>
          <div
            key={`rank-block-${rankIndex}`}
            style={{ height: `${rank.height}%` }}
            className={classNames(
              styles['graph__rank-block'],
              styles['graph__rank-block--expanded']
            )}>
            {rank.instrumentBlocks.map((instrument, instrumentIndex) => {
              return (
                <OpmInstrumentBlockComponent
                  key={`instrument-block-component-${instrumentIndex}-${instrument.instrumentId}`}
                  forecastData={forecastData}
                  forecastIndex={forecastIndex}
                  instrument={instrument}
                  chartForecastsCount={chartForecastsCount}
                  enableTooltip={false}
                />
              );
            })}
          </div>
        </Fragment>
      );
    })}
  </>
);

export default RankedInstrumentBlock;
